export var Provider;
(function (Provider) {
    Provider["Twitch"] = "twitch";
    Provider["Google"] = "google";
    Provider["TikTok"] = "tiktok";
    /**
     * Signs in and links, like the others, but it is not a creator channel: it has no
     * `Platform`, no follower count and no place in `userData.tokens`. It appears in
     * the sign-in dialog and as its own row in Connected Channels, never in the
     * Connect Channels buttons, which are for creator platforms.
     */
    Provider["Discord"] = "discord";
})(Provider || (Provider = {}));
